import React from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import { ENTITY_TYPES } from '@adsk/bim360-matrix-react-entity-linker';
import { statusColorMapping } from './consts';
import { getStatusFromServerStatus } from './getPropsFromEntity';
import EntityPickerItem from '../../EntityPickerItem';

/**
 * A component rendering RFI entity picker item.
 * @param entity
 * @param rest
 * @returns {*}
 * @constructor
 */
const RfiEntityPickerItem = ({ entity, ...rest }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
  const { id, status: serverStatus, title, identifier } = entity;
  const status = getStatusFromServerStatus(serverStatus);
  const userFriendlyId = identifier ? `#${identifier}` : identifier;
  const statusColor = status ? statusColorMapping[status] : null;
  const statusTextKey = status ? status.toUpperCase() : null;
  const statusText = statusTextKey ? T.translate(statusTextKey) : null;

  return (
    <EntityPickerItem
      entityType={ENTITY_TYPES.RFI}
      id={id}
      title={title}
      userFriendlyId={userFriendlyId}
      statusColor={statusColor}
      statusText={statusText}
      {...rest}
    />
  );
};

RfiEntityPickerItem.propTypes = {
  /**
   * The RFI entity we need to render.
   */
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    attributes: PropTypes.shape({
      title: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      identifier: PropTypes.number.isRequired
    })
  }).isRequired
};

export default RfiEntityPickerItem;
